import QRious from 'qrious'
import React, { useEffect, useRef } from 'react'

export const QRCode = ({ text, size }) => {
    const canvas = useRef(null)
    useEffect(() => {
        if (canvas != null && canvas.current != null) {
            const qr = new QRious({
                element: canvas.current,
                value: text,
                size: size,
            })
        }
    }, [])
    return <canvas ref={canvas}></canvas>
}
